@for (cinema of data().cinemas; track cinema.id_cinema) {
  @let cinemasScreensLength = cinema.screens?.length;
  @for (screen of cinema.screens; track screen.screen_id) {
    @let programme = getProgrammesByScreen(screen.screen_id)[programmeIndex()];
    @if (programme) {
      <td
        app-planning-region-cell
        [wednesday]="wednesday()"
        [programme]="programme"
        [data]="data()"
        [dateValue]="dateValue()"
        [screen]="screen"
        (reloadProgrammes)="reloadProgrammes()"
        [ngClass]="{'td-cinema': cinemasScreensLength == ($index + 1)}">
      </td>
    }
    @else {
      <td
        app-planning-region-empty-cell
        [screen]="screen"
        [wednesday]="wednesday()"
        [data]="data()"
        [dateValue]="dateValue()"
        [ngClass]="{'td-cinema': cinemasScreensLength == ($index + 1)}">
      </td>
    }
  }
}
